import { useEffect, useState } from 'react';

export function useDocumentTitle(pageTitleConfig = {}) {
  const [currentRoute, setCurrentRoute] = useState('');

  useEffect(() => {
    let title = pageTitleConfig[currentRoute];
    if (!title) {
      title = 'CMS-ACE Online';
    }
    document.title = title;
    // eslint-disable-next-line
  }, [currentRoute]);

  return [currentRoute, setCurrentRoute];
}
